// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"77cdc168","787":"1c7185b7"}[chunkId] + ".chunk.js";
};